import { render, staticRenderFns } from "./Coach.vue?vue&type=template&id=7f28571a&scoped=true&"
import script from "./Coach.vue?vue&type=script&lang=js&"
export * from "./Coach.vue?vue&type=script&lang=js&"
import style0 from "./Coach.vue?vue&type=style&index=0&id=7f28571a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f28571a",
  null
  
)

export default component.exports